module.exports = __webpack_public_path__ + "img/editornote1.cacde9eb.png";